<div
  #trigger
  class="accessible-select-trigger"
  role="combobox"
  [id]="id"
  [ngClass]="triggerClass"
  [class.is-invalid]="invalid"
  [attr.tabindex]="disabled ? -1 : 0"
  aria-haspopup="listbox"
  [attr.aria-expanded]="isOpen"
  [attr.aria-controls]="listboxId"
  [attr.aria-activedescendant]="activeDescendant"
  [attr.aria-label]="ariaLabel"
  [attr.aria-labelledby]="ariaLabelledby"
  [attr.aria-describedby]="ariaDescribedby"
  [attr.aria-required]="isRequired ? true : null"
  [attr.aria-invalid]="invalid ? true : null"
  [attr.aria-disabled]="disabled ? true : null"
  (click)="onTriggerClick($event)"
  (keydown)="onTriggerKeydown($event)"
  (blur)="onTriggerBlur()">
  <span class="accessible-select-value" [class.is-placeholder]="!hasValue">{{ triggerLabel }}</span>
  <span class="accessible-select-caret" aria-hidden="true"></span>
</div>

<ul
  *ngIf="isOpen"
  role="listbox"
  [id]="listboxId"
  [attr.aria-label]="ariaLabel"
  [ngClass]="panelClass"
  class="accessible-select-listbox">
  <li
    *ngFor="let option of options; let i = index"
    role="option"
    [id]="optionId(i)"
    [attr.aria-selected]="isSelected(option)"
    [attr.aria-disabled]="option?.disabled ? true : null"
    class="accessible-select-option"
    [class.active]="i === activeIndex"
    [class.selected]="isSelected(option)"
    (click)="onOptionClick(option, i, $event)"
    (mouseenter)="onOptionMouseenter(i)">
    {{ displayWith(option) }}
  </li>
</ul>
